var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgOkayIcon = function SvgOkayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.543 1.332L11.796.179c-.485-.314-1.154-.204-1.497.25l-4.758 6.37-2.634-1.726c-.476-.321-1.154-.212-1.488.243L.19 6.964A.972.972 0 00.45 8.36l3.512 2.306.025.016 1.722 1.137c.243.157.535.212.803.165a1.1 1.1 0 00.694-.416l6.597-8.84a.96.96 0 00-.259-1.396z"
  })));
};
export default SvgOkayIcon;